import { format, fromUnixTime } from "date-fns";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../../../firebaseConfig";

/**
 * Format date from Firestore timestamp
 * @param {Object} timestamp - Firestore timestamp with seconds property
 * @returns {string} Formatted date string
 */
export const formatDate = (timestamp) => {
  if (!timestamp?.seconds) return "-";
  const date = fromUnixTime(timestamp.seconds);
  return format(date, "MM.dd.yyyy");
};

/**
 * Format date and time from Firestore timestamp
 * @param {Object} timestamp - Firestore timestamp with seconds property
 * @returns {string} Formatted date and time string
 */
export const formatDateTime = (timestamp) => {
  if (!timestamp?.seconds) return "-";
  const date = new Date(timestamp.seconds * 1000);
  return date.toLocaleString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
};

/**
 * Format date for display
 * @param {Object} timestamp - Firestore timestamp with seconds property
 * @returns {string} Formatted date string
 */
export const formatDateDisplay = (timestamp) => {
  if (!timestamp?.seconds) return "-";
  const date = new Date(timestamp.seconds * 1000);
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

/**
 * Format time for display
 * @param {Object} timestamp - Firestore timestamp with seconds property
 * @returns {string} Formatted time string
 */
export const formatTimeDisplay = (timestamp) => {
  if (!timestamp?.seconds) return "-";
  const date = new Date(timestamp.seconds * 1000);
  return date.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
  });
};

/**
 * Generate random barcode value
 * @returns {string} Random 9-digit barcode
 */
export const generateRandomBarcodeValue = () => {
  return Math.floor(100000000 + Math.random() * 900000000).toString();
};

/**
 * Generate random slip number
 * @returns {number} Random 6-digit slip number
 */
export const generateSlipNumber = () => {
  return Math.floor(100000 + Math.random() * 900000);
};

/**
 * Get user name from Firestore
 * @param {string} userId - User ID
 * @returns {Promise<string>} User name or "No Name"
 */
export const getUserName = async (userId) => {
  try {
    const userDocRef = doc(db, "users", userId);
    const userDoc = await getDoc(userDocRef);

    if (userDoc.exists()) {
      return userDoc.data()?.name || "No Name";
    }
    return "No Name";
  } catch (error) {
    console.error("Error fetching user name:", error);
    return "No Name";
  }
};

